export interface IProcess {
    process_id: string;
    process_name: string;
    process_identifier_name: string;
    last_modified: string;
    version_id: number;
    author: number;
    algorithm_category: string;
    api_key: string;
    process_type: string;
    process_payload_schema: any;
    description: string;
    is_exposed: boolean;
}

export interface IProcessPayloadSchema {
    inputs: Array<IProcessPayloadSchemaInput>;
    outputs: Array<any>;
}

export interface IProcessPayloadSchemaInput {
    name: string;
    iiq_identifier: string;
    description: string;
    format: IProcessPayloadSchemaInputFormat;
    enabled: boolean;
    default: string;
    is_folder_field: boolean;
    can_have_multiple: boolean;
}

export interface IProcessPayloadSchemaInputFormat {
    type: string;
    enum: string;
    min_number: number;
    max_number: number;
    regex: any;
}

export interface IProcessPayloadUserInput {
    id: number;
    input: IProcessPayloadSchemaInput;
    type: ProcessPayloadUserInputType;
    isMultiple: boolean;
    values: Array<any>;
}

export interface IRunningProcess {
    process_id: string;
    process_name: string;
    task_id: string;
}

export interface ITaskInformation {
    state: string;
    complete: boolean;
    success: boolean;
    progress: ITaskProgressInformation;
    result: object;
}

export interface ITaskProgressInformation {
    current: number;
    total: number;
    etc: string;
}

export interface IHistoricProcess {
    created_at: string;
    process_id: string;
    process_name: string;
    task_id: string;
    task_status: string;
}

export enum ProcessPayloadUserInputType {
    FOLDER_FIELDS,
    ENUM_VALUES,
    TEXT,
    NUMERIC,
}
